<blockable-div id="monlogs-details-container" #details>
  <app-progress-spinner [enabled]="!form" />
  <p-blockUI
    [blocked]="saving === true || loading === true"
    [target]="details"
  />
  @if (form) {
    <form [formGroup]="form" id="monlog-create-form">
      @if (!this._deviceService.isMobile()) {
        <div class="xtra-small-top-padding">
          <div id="contact-action-buttons">
            <div class="no-padding-top-bottom">
              @if (!monLog || !monLog.id) {
                <div class="action-items">
                  <div class="item-long">
                    <div>
                      <app-progress-spinner [enabled]="saving" />
                    </div>
                    @if (isEditting === false && canEdit === true) {
                      <div class="button-wrapper no-padding-top-bottom">
                        <button
                          pButton
                          label="{{ 'COMMON.LABEL.BUTTONS.EDIT' | translate }}"
                          icon="fa fa-fw fa-edit"
                          (click)="setEditting()"
                        ></button>
                      </div>
                    }
                    @if (
                      isEditting === true &&
                      (canEdit === true || canCreate === true)
                    ) {
                      <div
                        class="button-wrapper no-padding-top-bottom item-long"
                      >
                        <button
                          pButton
                          label="{{ 'COMMON.LABEL.BUTTONS.SAVE' | translate }}"
                          icon="fa fa-fw fa-save"
                          [disabled]="!this.form.valid || this.saving"
                          (click)="saveMonitoringLog()"
                        ></button>
                      </div>
                    }
                    <div class="button-wrapper">
                      @if ($safeNavigationMigration(monLog?.id) !== null) {
                        <button
                          pButton
                          class="refresh-button"
                          icon="fa fa-fw fa-refresh"
                          (click)="refresh()"
                        ></button>
                      }
                    </div>
                  </div>
                </div>
              }
              <div class="columns">
                @if (monLog?.id) {
                  <div class="no-padding-top-bottom column">
                    <div class="column-item">
                      <span class="label no-padding-top-bottom"
                        >{{ 'MONLOG.LABEL.CREATED_BY' | translate }}:</span
                      >
                      <span class="free-text-value no-padding-top-bottom"
                        >{{ monLog?.createdBy }}
                        on
                        {{
                          $safeNavigationMigration(monLog?.createdAt)
                            | date: 'MM/dd/yyyy hh:mm:ss a'
                        }}</span
                      >
                    </div>
                    <div class="column-item">
                      <span class="label no-padding-top-bottom"
                        >{{ 'MONLOG.LABEL.LAST_UPDATED' | translate }}:</span
                      >
                      <span class="free-text-value no-padding-top-bottom">{{
                        $safeNavigationMigration(monLog?.updatedAt)
                          | date: 'MM/dd/yyyy hh:mm:ss a'
                      }}</span>
                    </div>
                    <div class="column-item">
                      <span
                        class="label no-padding-top-bottom; margin-right: 8px"
                        >{{ 'MONLOG.LABEL.CURRENT_STATUS' | translate }}:</span
                      >
                      @if (monLog?.logStatus === 'O') {
                        <span class="free-text-value no-padding-top-bottom">{{
                          'MONLOG.LABEL.OPEN' | translate
                        }}</span>
                      }
                      @if (monLog?.logStatus === 'A') {
                        <span class="free-text-value no-padding-top-bottom">{{
                          'MONLOG.LABEL.AWAITING_REVIEW' | translate
                        }}</span>
                      }
                      @if (monLog?.logStatus === 'C') {
                        <span class="free-text-value no-padding-top-bottom">{{
                          'MONLOG.LABEL.REVIEW_COMPLETE' | translate
                        }}</span>
                      }
                      @if (monLog?.logStatus === 'R') {
                        <span class="free-text-value no-padding-top-bottom">{{
                          'MONLOG.LABEL.RESOLVED' | translate
                        }}</span>
                      }
                    </div>
                    @if (monLog?.reviewRequestedDt) {
                      <div class="column-item">
                        <span class="label no-padding-top-bottom"
                          >{{
                            'MONLOG.LABEL.REVIEW_REQUESTED' | translate
                          }}:</span
                        >
                        @if (monLog?.reviewRequestedDt) {
                          <span class="free-text-value no-padding-top-bottom">{{
                            $safeNavigationMigration(monLog?.reviewRequestedDt)
                              | date: 'yyyy-MM-dd HH:mm:ss'
                          }}</span>
                        }
                      </div>
                    }
                    <div class="column-item">
                      @if (monLog?.reviewCompletedDt) {
                        <span class="label no-padding-top-bottom">
                          {{
                            'MONLOG.LABEL.REVIEW_COMPLETED' | translate
                          }}:</span
                        >
                      }
                      @if (monLog?.reviewCompletedDt) {
                        <span class="free-text-value no-padding-top-bottom">
                          {{
                            $safeNavigationMigration(monLog?.reviewCompletedDt)
                              | date: 'yyyy-MM-dd HH:mm:ss'
                          }}</span
                        >
                      }
                      @if (monLog?.reviewer) {
                        <span class="label no-padding-top-bottom reviewer">
                          {{ 'MONLOG.LABEL.REVIEWER' | translate }}:</span
                        >
                      }
                      @if (monLog?.reviewer) {
                        <span class="free-text-value no-padding-top-bottom">
                          {{ monLog?.reviewer }}</span
                        >
                      }
                    </div>
                  </div>
                }
                @if (monLog?.id) {
                  <div class="no-padding-top-bottom column">
                    @if (monLog?.id) {
                      <div
                        class="button-wrapper no-padding-top-bottom row-item"
                      >
                        <span
                          style="
                            font-weight: 700;
                            text-align: right;
                            padding-right: 0.25em;
                          "
                          >{{ 'COMMON.LABEL.ACTIONS' | translate }}:</span
                        >
                        <span
                          class="no-padding-top-bottom"
                          style="text-align: left !important"
                        >
                          <p-select
                            #dd
                            [options]="actions"
                            [(ngModel)]="selectedAction"
                            [ngModelOptions]="{ standalone: true }"
                            (onChange)="actionEvent($event, dd)"
                            scrollHeight="calc(100vh - 35vh)"
                            styleclass="action-drop-down"
                          />
                        </span>
                        <div
                          class="no-padding-top-bottom display-flex"
                          style="text-align: right; margin-left: 8px"
                        >
                          <div>
                            <app-progress-spinner [enabled]="saving" />
                          </div>
                          @if (isEditting === false && canEdit === true) {
                            <div class="button-wrapper no-padding-top-bottom">
                              <button
                                pButton
                                label="{{
                                  'COMMON.LABEL.BUTTONS.EDIT' | translate
                                }}"
                                icon="fa fa-fw fa-edit"
                                (click)="setEditting()"
                              ></button>
                            </div>
                          }
                          @if (isEditting === true && canEdit === true) {
                            <div class="button-wrapper no-padding-top-bottom">
                              <button
                                pButton
                                label="{{
                                  'COMMON.LABEL.BUTTONS.SAVE' | translate
                                }}"
                                icon="fa fa-fw fa-save"
                                [disabled]="!this.form.valid || this.saving"
                                (click)="saveMonitoringLog()"
                              ></button>
                            </div>
                          }
                          <div class="button-wrapper">
                            @if (monLog?.logId) {
                              <button
                                pButton
                                class="copy-button"
                                icon="fa fa-fw fa-clone"
                                (click)="copyLogId()"
                                pTooltip="{{
                                  'MONLOG.TOOLTIP.COPY_LOG_ID' | translate
                                }}"
                                tooltipPosition="bottom"
                              ></button>
                            }
                          </div>
                          <div class="button-wrapper">
                            @if (
                              $safeNavigationMigration(monLog?.id) !== null
                            ) {
                              <button
                                pButton
                                class="refresh-button"
                                icon="fa fa-fw fa-refresh"
                                (click)="refresh()"
                              ></button>
                            }
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                }
              </div>
              <div class="columns">
                <div class="status-summary column-long">
                  <div class="column-item">
                    <span class="label"
                      >{{ 'MONLOG.LABEL.STATUS_SUMMARY' | translate }}:</span
                    >
                    <span class="input">
                      <input pInputText formControlName="statusSummary" />
                      <app-inline-validation
                        class="input-field"
                        field="statusSummary"
                        [control]="getBaseFormChild('statusSummary')"
                        [validationMessages]="validationMessages"
                        [validationParams]="validationParams"
                      />
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <p-tabs (onChange)="indexChanged($event)" [value]="tabIndex">
            <p-tablist>
              <p-tab [value]="0">{{
                'MONLOG.LABEL.CALL_INFORMATION' | translate
              }}</p-tab>
              @if (monLog?.id && isAlarm) {
                <p-tab [value]="1">{{
                  'MONLOG.LABEL.ALARMS' | translate
                }}</p-tab>
              }
              @if (
                monLog?.id &&
                monLog?.logCategory !== 'MR' &&
                monLog?.logCategory !== 'AE'
              ) {
                <p-tab [value]="monLog?.id && isAlarm ? 2 : 1">{{
                  'MONLOG.LABEL.ENTRIES' | translate
                }}</p-tab>
              }
              <p-tab
                [value]="
                  monLog?.id &&
                  monLog?.logCategory !== 'MR' &&
                  monLog?.logCategory !== 'AE' &&
                  isAlarm
                    ? 3
                    : (monLog?.id &&
                          monLog?.logCategory !== 'MR' &&
                          monLog?.logCategory !== 'AE') ||
                        (monLog?.id && isAlarm)
                      ? 2
                      : 1
                "
                >{{ 'MONLOG.LABEL.NOTIFICATIONS_AND_AUDIT' | translate }}</p-tab
              >
              @if (
                this.canViewEventReview() && this.doesAnyTypeRequireReview()
              ) {
                <p-tab
                  [value]="
                    monLog?.id &&
                    monLog?.logCategory !== 'MR' &&
                    monLog?.logCategory !== 'AE' &&
                    monLog?.id &&
                    isAlarm
                      ? 4
                      : (monLog?.id &&
                            monLog?.logCategory !== 'MR' &&
                            monLog?.logCategory !== 'AE') ||
                          (monLog?.id && isAlarm)
                        ? 3
                        : 2
                  "
                  >{{ 'MONLOG.LABEL.EVENT_REVIEW' | translate }}</p-tab
                >
              }
            </p-tablist>
            <p-tabpanels>
              <p-tabpanel [value]="0">
                <p-panel
                  [showHeader]="false"
                  class="flex"
                  styleclass="mon-log-panel"
                >
                  <div class="form-section">
                    <div
                      class="section-element"
                      [class.long]="
                        monLog?.logCategory !== 'MR' &&
                        monLog?.logCategory !== 'AE'
                      "
                    >
                      <span class="label"
                        ><span class="asterisk-call-type">*</span
                        >{{ 'MONLOG.LABEL.TYPE_OF_CALL' | translate }}:</span
                      >
                      <span class="row-input">
                        <p-multiSelect
                          class="input"
                          [options]="types"
                          [maxSelectedLabels]="10"
                          (onChange)="callTypeChange($event)"
                          formControlName="typeOfCalls"
                          styleclass="multiselect-resize"
                          [autofocusFilter]="true"
                          id="call-type"
                          appendTo="body"
                        />
                        <app-inline-validation
                          field="typeOfCalls"
                          class="validation"
                          [control]="getBaseFormChild('typeOfCalls')"
                          [validationMessages]="validationMessages"
                          [validationParams]="validationParams"
                        />
                      </span>
                    </div>
                    @if (
                      monLog?.logCategory !== 'MR' &&
                      monLog?.logCategory !== 'AE'
                    ) {
                      <div class="short section-element">
                        <span class="label"
                          >{{
                            'MONLOG.LABEL.CUSTOMER_OUTAGE' | translate
                          }}:</span
                        >
                        <span class="row-input radio">
                          <div>
                            <label>{{
                              'COMMON.LABEL.BUTTONS.YES' | translate
                            }}</label>
                            <p-radiobutton
                              name="customerOutage"
                              [value]="true"
                              formControlName="customerOutage"
                            />
                          </div>
                          <div>
                            <label>{{
                              'COMMON.LABEL.BUTTONS.NO' | translate
                            }}</label>
                            <p-radiobutton
                              name="customerOutage"
                              [value]="false"
                              formControlName="customerOutage"
                            />
                          </div>
                        </span>
                      </div>
                    }
                    @if (
                      monLog?.logCategory !== 'MR' &&
                      monLog?.logCategory !== 'AE'
                    ) {
                      <div class="short section-element">
                        <span class="label"
                          >{{
                            'MONLOG.LABEL.CALLOUT_REQUIRED' | translate
                          }}:</span
                        >
                        <span class="row-input radio">
                          <div>
                            <label>{{
                              'COMMON.LABEL.BUTTONS.YES' | translate
                            }}</label>
                            <p-radiobutton
                              name="calloutRequired"
                              [value]="true"
                              formControlName="calloutRequired"
                            />
                          </div>
                          <div>
                            <label>{{
                              'COMMON.LABEL.BUTTONS.NO' | translate
                            }}</label>
                            <p-radiobutton
                              name="calloutRequired"
                              [value]="false"
                              formControlName="calloutRequired"
                            />
                          </div>
                          <app-inline-validation
                            field="calloutRequired"
                            [control]="getBaseFormChild('calloutRequired')"
                            [validationMessages]="validationMessages"
                            [validationParams]="validationParams"
                          />
                        </span>
                      </div>
                    }
                    @if (
                      monLog?.logCategory !== 'MR' &&
                      monLog?.logCategory !== 'AE'
                    ) {
                      <div class="short section-element">
                        <span class="label"
                          >{{ 'MONLOG.LABEL.FALSE_ALARM' | translate }}:</span
                        >
                        <span class="row-input radio">
                          <div>
                            <label>{{
                              'COMMON.LABEL.BUTTONS.YES' | translate
                            }}</label>
                            <p-radiobutton
                              name="falseAlarm"
                              [value]="true"
                              formControlName="falseAlarm"
                            />
                          </div>
                          <div>
                            <label>{{
                              'COMMON.LABEL.BUTTONS.NO' | translate
                            }}</label>
                            <p-radiobutton
                              name="falseAlarm"
                              [value]="false"
                              formControlName="falseAlarm"
                            />
                          </div>
                        </span>
                      </div>
                    }
                    @if (
                      monLog?.logCategory !== 'MR' &&
                      monLog?.logCategory !== 'AE'
                    ) {
                      <div class="section-element">
                        <span class="label"
                          >{{ 'MONLOG.LABEL.TIME_BEGAN' | translate }}:</span
                        >
                        <span class="row-input">
                          <div class="ui-inputgroup">
                            <p-datepicker
                              class="input"
                              [timeOnly]="true"
                              [showSeconds]="true"
                              hourFormat="12"
                              formControlName="timeBegan"
                            />
                            <span class="addon"
                              ><i
                                class="fa fa-clock-o clock-icon"
                                (click)="setTimeBegan()"
                              ></i
                            ></span>
                          </div>
                        </span>
                      </div>
                    }
                    @if (
                      monLog?.logCategory !== 'MR' &&
                      monLog?.logCategory !== 'AE'
                    ) {
                      <div class="section-element">
                        <span class="label"
                          >{{ 'MONLOG.LABEL.TIME_ON_SITE' | translate }}:</span
                        >
                        <span class="row-input">
                          <div class="ui-inputgroup">
                            <p-datepicker
                              class="input"
                              [timeOnly]="true"
                              hourFormat="12"
                              formControlName="timeOnSite"
                              [showSeconds]="true"
                            />
                            <span class="addon"
                              ><i
                                class="fa fa-clock-o clock-icon"
                                (click)="setTimeOnSite()"
                              ></i
                            ></span>
                          </div>
                        </span>
                      </div>
                    }
                    @if (
                      monLog?.logCategory !== 'MR' &&
                      monLog?.logCategory !== 'AE'
                    ) {
                      <div class="section-element">
                        <span class="label"
                          >{{ 'MONLOG.LABEL.ONE_CALL_NO' | translate }}:</span
                        >
                        <span class="row-input">
                          <input
                            class="input"
                            pInputText
                            formControlName="oneCallNumber"
                          />
                        </span>
                      </div>
                    }
                    @if (
                      monLog?.logCategory !== 'MR' &&
                      monLog?.logCategory !== 'AE'
                    ) {
                      <div class="section-element">
                        <span class="label"
                          >{{ 'MONLOG.LABEL.TICKET_NUMBER' | translate }}:</span
                        >
                        <span class="row-input">
                          <input
                            class="input"
                            pInputText
                            formControlName="ticketNumber"
                          />
                        </span>
                      </div>
                    }
                    @if (showAEWorkTypes === true) {
                      <div
                        class="section-element"
                        [class.long-ae-mr]="
                          monLog?.logCategory === 'MR' ||
                          monLog?.logCategory === 'AE'
                        "
                      >
                        <span class="label"
                          ><span class="asterisk">*</span
                          >{{ 'MONLOG.LABEL.WORK_TYPE' | translate }}:</span
                        >
                        <span class="row-input">
                          <p-multiSelect
                            class="input"
                            [options]="aeWorkTypes"
                            [maxSelectedLabels]="10"
                            formControlName="workTypes"
                          />
                          <app-inline-validation
                            field="workType"
                            [control]="getBaseFormChild('workTypes')"
                            [validationMessages]="validationMessages"
                            [validationParams]="validationParams"
                          />
                        </span>
                      </div>
                    }
                    @if (
                      showMRWorkTypes === true &&
                      (monLog?.logCategory === 'MR' ||
                        monLog?.logCategory === 'AE')
                    ) {
                      <div class="section-element long-ae-mr">
                        <span class="label"
                          ><span class="asterisk">*</span
                          >{{ 'MONLOG.LABEL.WORK_TYPE' | translate }}:</span
                        >
                        <span class="row-input">
                          <p-multiSelect
                            class="input"
                            [options]="mrWorkTypes"
                            [maxSelectedLabels]="10"
                            formControlName="workTypes"
                          />
                          <app-inline-validation
                            field="workType"
                            [control]="getBaseFormChild('workTypes')"
                            [validationMessages]="validationMessages"
                            [validationParams]="validationParams"
                          />
                        </span>
                      </div>
                    }
                    @if (
                      showGasReleaseType === true &&
                      monLog?.logCategory !== 'MR' &&
                      monLog?.logCategory !== 'AE'
                    ) {
                      <div class="section-element">
                        <span class="label"
                          ><span class="asterisk">*</span
                          >{{
                            'MONLOG.LABEL.GAS_RELEASE_TYPE' | translate
                          }}:</span
                        >
                        <span class="row-input">
                          <p-select
                            class="input"
                            [options]="gasReleaseTypes"
                            formControlName="gasReleaseType"
                          />
                          <app-inline-validation
                            field="gasReleaseType"
                            [control]="getBaseFormChild('gasReleaseType')"
                            [validationMessages]="validationMessages"
                            [validationParams]="validationParams"
                          />
                        </span>
                      </div>
                    }
                    @if (
                      showSeverity === true &&
                      monLog?.logCategory !== 'MR' &&
                      monLog?.logCategory !== 'AE'
                    ) {
                      <div class="section-element">
                        <span class="asterisk">*</span>
                        <span class="label"
                          >{{ 'MONLOG.LABEL.SEVERITY' | translate }}:</span
                        >
                        <span class="row-input">
                          <p-select
                            class="input"
                            [options]="commFailSeverities"
                            formControlName="commFailSeverity"
                          />
                          <app-inline-validation
                            field="commFailSeverity"
                            [control]="getBaseFormChild('commFailSeverity')"
                            [validationMessages]="validationMessages"
                            [validationParams]="validationParams"
                          />
                        </span>
                      </div>
                    }
                    @if (
                      showNotam === true &&
                      monLog?.logCategory !== 'MR' &&
                      monLog?.logCategory !== 'AE'
                    ) {
                      <div class="section-element">
                        <span class="label"
                          >{{ 'MONLOG.LABEL.NOTAM' | translate }}:</span
                        >
                        <span class="row-input">
                          <input
                            class="input"
                            pInputText
                            formControlName="notam"
                          />
                        </span>
                      </div>
                    }
                    <div class="row">
                      @if (
                        showNotam === true &&
                        monLog?.logCategory !== 'MR' &&
                        monLog?.logCategory !== 'AE'
                      ) {
                        <div class="row-item-short no-padding-top-bottom">
                          <span class="label"
                            >{{ 'MONLOG.LABEL.EXPIRE_DT' | translate }}:</span
                          >
                          <span class="row-input">
                            <p-datepicker
                              class="input"
                              formControlName="expireDt"
                            />
                          </span>
                        </div>
                      }
                    </div>
                  </div>
                </p-panel>
                <p-panel
                  header="{{ 'MONLOG.LABEL.CALLER_LOCATION_INFO' | translate }}"
                  styleclass="mon-log-panel"
                  [toggleable]="true"
                >
                  <div
                    class="form-section"
                    [style.--columns]="
                      monLog?.logCategory === 'MR' ||
                      monLog?.logCategory === 'AE'
                        ? '3'
                        : '7'
                    "
                  >
                    @if (monLog?.logCategory === 'N') {
                      <div class="section-element">
                        <span class="label"
                          >{{ 'CONTACT.LABEL.FIRST_NAME' | translate }}:</span
                        >
                        <span class="row-input">
                          <input
                            class="input"
                            pInputText
                            formControlName="firstName"
                          />
                        </span>
                      </div>
                    }
                    @if (monLog?.logCategory === 'N') {
                      <div class="section-element">
                        <span class="label"
                          >{{ 'CONTACT.LABEL.LAST_NAME' | translate }}:</span
                        >
                        <span class="row-input">
                          <input
                            class="input"
                            pInputText
                            formControlName="lastName"
                          />
                        </span>
                      </div>
                    }
                    @if (monLog?.logCategory === 'N') {
                      <div class="section-element">
                        <span class="label"
                          >{{ 'MONLOG.LABEL.PHONE' | translate }}:</span
                        >
                        <span class="row-input">
                          <p-inputMask
                            class="input"
                            mask="999-999-9999"
                            id="businessPhone"
                            formControlName="phone"
                            (onBlur)="fixMask('phone')"
                          />
                        </span>
                      </div>
                    }
                    @if (monLog?.logCategory === 'N') {
                      <div class="section-element">
                        <span class="label"
                          >{{ 'MONLOG.LABEL.STREET' | translate }}:</span
                        >
                        <span class="row-input">
                          <input
                            class="input"
                            pInputText
                            formControlName="street"
                          />
                        </span>
                      </div>
                    }
                    @if (
                      monLog?.logCategory === 'I' ||
                      monLog?.logCategory === 'MR' ||
                      monLog?.logCategory === 'AE'
                    ) {
                      <div class="section-element">
                        <span class="label"
                          >{{
                            'MONLOG.LABEL.INTERNAL_CONTACT_ONE' | translate
                          }}:</span
                        >
                        @if (
                          canEdit === true &&
                          (monLog?.logCategory === 'MR' ||
                            monLog?.logCategory === 'AE')
                        ) {
                          <span
                            class="input-icon text-right"
                            style="margin-right: 8px"
                          >
                            <i
                              class="fa fa-fw fa-phone-square"
                              (click)="addControllerEntry(0)"
                            ></i>
                          </span>
                        }
                        <span class="internal">
                          <p-autoComplete
                            class="input internal"
                            [suggestions]="filteredContacts"
                            formControlName="internalOne"
                            [dropdown]="true"
                            optionLabel="fullName"
                            (completeMethod)="contactSearch($event, true)"
                            appendTo="body"
                            [forceSelection]="true"
                            [virtualScroll]="true"
                            [virtualScrollItemSize]="34"
                          />
                        </span>
                      </div>
                    }
                    @if (
                      monLog?.logCategory === 'I' ||
                      monLog?.logCategory === 'MR' ||
                      monLog?.logCategory === 'AE'
                    ) {
                      <div class="section-element">
                        <span class="label"
                          >{{
                            'MONLOG.LABEL.INTERNAL_CONTACT_TWO' | translate
                          }}:</span
                        >
                        @if (
                          canEdit === true &&
                          (monLog?.logCategory === 'MR' ||
                            monLog?.logCategory === 'AE')
                        ) {
                          <span
                            class="input-icon text-right"
                            style="margin-right: 8px"
                          >
                            <i
                              class="fa fa-fw fa-phone-square"
                              (click)="addControllerEntry(1)"
                            ></i>
                          </span>
                        }
                        <span class="internal">
                          <p-autoComplete
                            class="input internal"
                            [suggestions]="filteredContacts"
                            formControlName="internalTwo"
                            [dropdown]="true"
                            optionLabel="fullName"
                            (completeMethod)="contactSearch($event, true)"
                            appendTo="body"
                            [forceSelection]="true"
                            [virtualScroll]="true"
                            [virtualScrollItemSize]="34"
                          />
                        </span>
                      </div>
                    }
                  </div>
                  @if (
                    monLog?.logCategory !== 'MR' && monLog?.logCategory !== 'AE'
                  ) {
                    <div class="form-section">
                      <div class="section-element">
                        <span class="label"
                          >{{ 'LOCATION.LABEL.STATE' | translate }}:</span
                        >
                        <span class="row-input">
                          <p-autoComplete
                            class="input"
                            [suggestions]="filteredStates"
                            (completeMethod)="stateSearch($event)"
                            (onSelect)="selectState($event, this.form)"
                            formControlName="state"
                            [dropdown]="true"
                            appendTo="body"
                            [virtualScroll]="true"
                            [virtualScrollItemSize]="34"
                          />
                        </span>
                      </div>
                      <div class="section-element">
                        <span class="label"
                          >{{ 'LOCATION.LABEL.COUNTY' | translate }}:</span
                        >
                        <span class="row-input">
                          <p-autoComplete
                            class="input"
                            [suggestions]="filteredCounties"
                            (completeMethod)="countySearch($event, this.form)"
                            formControlName="county"
                            [dropdown]="true"
                            optionLabel="county"
                            (onSelect)="selectCounty($event, this.form)"
                            appendTo="body"
                            [virtualScroll]="true"
                            [virtualScrollItemSize]="34"
                          />
                        </span>
                      </div>
                      <div class="section-element">
                        <span class="label"
                          >{{ 'LOCATION.LABEL.TOWNSHIP' | translate }}:</span
                        >
                        <span class="row-input">
                          <p-autoComplete
                            class="input"
                            [suggestions]="filteredTownships"
                            (completeMethod)="townshipSearch($event, this.form)"
                            formControlName="township"
                            [dropdown]="true"
                            optionLabel="township"
                            (onSelect)="selectTownship($event, this.form)"
                            appendTo="body"
                            [virtualScroll]="true"
                            [virtualScrollItemSize]="34"
                          />
                        </span>
                      </div>
                      <div class="section-element">
                        <span class="label"
                          >{{ 'LOCATION.LABEL.CITY' | translate }}:</span
                        >
                        <span class="row-input">
                          <input
                            class="input"
                            pInputText
                            formControlName="city"
                          />
                        </span>
                      </div>
                    </div>
                  }
                </p-panel>
                <p-panel
                  header="{{ 'MONLOG.LABEL.FACILITY_INFO' | translate }}"
                  styleclass="mon-log-panel row"
                  [toggleable]="true"
                >
                  <div class="row">
                    <div
                      class="form-section"
                      style="--columns: 8"
                      formGroupName="Facility"
                      [class.small-grid]="
                        ['I', 'O', 'N', 'MR', 'AE'].includes(
                          $safeNavigationMigration(monLog?.logCategory)!
                        )
                      "
                    >
                      <div
                        class="section-element"
                        [class.long]="
                          ['I', 'O', 'N', 'MR', 'AE'].includes(
                            $safeNavigationMigration(monLog?.logCategory)!
                          )
                        "
                      >
                        <span class="label" [class.long-label]="isEditting">
                          <span style="margin-right: 8px">
                            @if (isEditting === true) {
                              <button
                                pButton
                                icon="fa fa-fw fa-eraser"
                                pTooltip="Clear Facility and Location"
                                (click)="resetFacility()"
                              ></button>
                            }</span
                          >{{ 'LOCATION.LABEL.FACILITY_TYPE' | translate }}:
                        </span>
                        <span class="row-input">
                          @if (!facilitiesLoading) {
                            <p-autoComplete
                              class="input"
                              [suggestions]="filteredFacilityTypes"
                              (completeMethod)="facilityTypeSearch($event)"
                              formControlName="facilityType"
                              [dropdown]="true"
                              appendTo="body"
                              [virtualScroll]="true"
                              [virtualScrollItemSize]="34"
                            />
                          }
                          @if (facilitiesLoading) {
                            <p-progressSpinner
                              [style]="{ width: '50px', height: '50px' }"
                            />
                          }
                        </span>
                      </div>
                      <div class="section-element long facility-name">
                        @if (showActiveVisitors) {
                          <button
                            type="button"
                            pButton
                            icon="fa fa-users"
                            pTooltip="View Signed-In Visitors"
                            (click)="openMusterListDialog()"
                          ></button>
                        }
                        @if (showActiveFacilityNotes) {
                          <button
                            pButton
                            icon="fa fa-commenting-o"
                            pTooltip="View Facility Notes"
                            (click)="openFacilityNotesDialog()"
                            class="facility-notes-btn"
                          ></button>
                        }
                        <span class="label"
                          >{{
                            'LOCATION.LABEL.FACILITY_NAME' | translate
                          }}:</span
                        >
                        <span class="row-input">
                          @if (!facilitiesLoading) {
                            <p-autoComplete
                              class="input"
                              [suggestions]="filteredFacilityNames"
                              (completeMethod)="facilityNameSearch($event)"
                              formControlName="facilityName"
                              [dropdown]="true"
                              optionLabel="facilityName"
                              (onSelect)="facilityNameSelected($event)"
                              appendTo="body"
                              [virtualScroll]="true"
                              [virtualScrollItemSize]="34"
                            />
                          }
                          @if (facilitiesLoading) {
                            <p-progressSpinner
                              [style]="{ width: '50px', height: '50px' }"
                            />
                          }
                        </span>
                      </div>
                      <div class="section-element facility-id">
                        <span class="label"
                          >{{
                            'LOCATION.LABEL.FACILITY_UID' | translate
                          }}:</span
                        >
                        <span class="row-input">
                          @if (!facilitiesLoading) {
                            <p-autoComplete
                              class="input"
                              [suggestions]="filteredFacilityIds"
                              (completeMethod)="facilityIdSearch($event)"
                              formControlName="facilityUid"
                              [dropdown]="true"
                              optionLabel="facilityUid"
                              (onSelect)="facilityIdSelected($event)"
                              appendTo="body"
                              [virtualScroll]="true"
                              [virtualScrollItemSize]="34"
                            />
                          }
                          @if (facilitiesLoading) {
                            <p-progressSpinner
                              [style]="{ width: '50px', height: '50px' }"
                            />
                          }
                        </span>
                      </div>
                      @if (
                        monLog?.logCategory !== 'MR' &&
                        monLog?.logCategory !== 'AE'
                      ) {
                        <div class="section-element">
                          <span class="label"
                            >{{ 'MONLOG.LABEL.PIPELINE' | translate }}:</span
                          >
                          <span class="row-input">
                            <input
                              class="input"
                              pInputText
                              formControlName="pipeline"
                            />
                          </span>
                        </div>
                      }
                      <div class="section-element">
                        <span class="label"
                          >{{ 'LOCATION.LABEL.AOR' | translate }}:</span
                        >
                        <span class="row-input">
                          <input
                            class="input"
                            pInputText
                            formControlName="aor"
                          />
                        </span>
                      </div>
                      <div class="section-element">
                        <span class="label"
                          ><span class="asterisk-business-unit">*</span>
                          {{ 'COMMON.LABEL.BUSINESS_UNIT' | translate }}:</span
                        >
                        <span class="row-input">
                          @if (!facilitiesLoading) {
                            <p-autoComplete
                              class="input"
                              [suggestions]="filteredBusinessUnits"
                              (completeMethod)="businessUnitSearch($event)"
                              formControlName="businessUnit"
                              [dropdown]="true"
                              optionLabel="name"
                              appendTo="body"
                              [virtualScroll]="true"
                              [virtualScrollItemSize]="34"
                            />
                          }
                        </span>
                      </div>
                    </div>
                  </div>
                </p-panel>
                <p-panel
                  header="{{ 'MONLOG.LABEL.PRIMARY_CONTACT_INFO' | translate }}"
                  styleclass="mon-log-panel"
                  [toggleable]="true"
                >
                  <div class="panel edit">
                    @for (
                      contact of getContactsControls();
                      track contact.getRawValue();
                      let i = $index
                    ) {
                      <div
                        class="panel no-padding-top-bottom small-panel"
                        formArrayName="MonLogContacts"
                      >
                        <div
                          [formGroupName]="i"
                          class="form-section"
                          style="--columns: 3"
                        >
                          <div
                            [class]="{
                              'section-element': !isEditting,
                              'edit-element': isEditting,
                              'unavailable-contact':
                                contact['controls'].primary.value
                                  ?.primaryIsUnavailable,
                            }"
                          >
                            <div class="label" [class.long-label]="isEditting">
                              <span>
                                @if (i !== 0 && isEditting === true) {
                                  <button
                                    pButton
                                    icon="fa fa-trash"
                                    pTooltip="Remove Contact Row"
                                    (click)="removeContactRow(i)"
                                  ></button>
                                }
                              </span>
                              @if (i === 0) {
                                <span
                                  [class.trash]="isEditting"
                                  [translate]="'MONLOG.LABEL.PRIMARY_CONTACT'"
                                ></span>
                              }
                              @if (i !== 0) {
                                <span
                                  style="margin-left: 0.2vw"
                                  [class.trash]="isEditting"
                                  [translate]="'MONLOG.LABEL.OTHER_CONTACT'"
                                  [translateParams]="{ index: i }"
                                ></span>
                              }
                              @if (
                                canEdit === true &&
                                this.monLog?.id &&
                                contact['controls'].primary.value
                                  ?.isPrimaryDispatched === false
                              ) {
                                <span class="input-icon text-right">
                                  <i
                                    class="fa fa-fw fa-phone-square"
                                    (click)="
                                      dispatchContact(
                                        $safeNavigationMigration(
                                          contact['controls'].primary.value
                                            ?.primaryId
                                        )
                                      )
                                    "
                                  ></i>
                                </span>
                              }
                              @if (
                                canEdit === true &&
                                this.monLog?.id &&
                                contact['controls'].primary.value
                                  ?.isPrimaryDispatched === true
                              ) {
                                <span class="input-icon text-right">
                                  <i
                                    class="fa fa-fw fa-home"
                                    (click)="
                                      returnContact(
                                        $safeNavigationMigration(
                                          contact['controls'].primary.value
                                            ?.primaryId
                                        )
                                      )
                                    "
                                  ></i>
                                </span>
                              }
                              @if (contact['controls'].primary.value === null) {
                                <span class="input-icon text-right"> </span>
                              }
                            </div>
                            <span class="input-icon" style="width: 32px">
                              <i
                                class="fa fa-fw fa-id-card"
                                (click)="
                                  goToContact(
                                    contact['controls'].primary.value.primaryId
                                  )
                                "
                              ></i>
                            </span>
                            <span class="row-input-contact">
                              <p-autoComplete
                                class="ml-contact-input"
                                [suggestions]="filteredContacts"
                                formControlName="primary"
                                [dropdown]="true"
                                optionLabel="primaryFullName"
                                (onSelect)="contactSelected(i, $event)"
                                (completeMethod)="contactSearch($event)"
                                appendTo="body"
                                [forceSelection]="true"
                                [virtualScroll]="true"
                                [virtualScrollItemSize]="34"
                              />
                            </span>
                            <div class="section-element">
                              <div class="label business-mobile">
                                <span
                                  [translate]="'MONLOG.LABEL.BUSINESS_MOBILE'"
                                ></span>
                              </div>
                              <a
                                href="tel:9-1-{{
                                  contact['controls'].primary.value
                                    ?.primaryBusinessMobile
                                }}"
                                >{{
                                  contact['controls'].primary.value
                                    ?.primaryBusinessMobile
                                }}</a
                              >
                            </div>
                          </div>
                          <div
                            [class]="{
                              'section-element': !isEditting,
                              'edit-element': isEditting,
                              'unavailable-contact':
                                contact['controls'].primary.value
                                  ?.secondaryIsUnavailable,
                            }"
                          >
                            <div class="label" [class.long-label]="isEditting">
                              @if (i === 0) {
                                <span
                                  [translate]="'MONLOG.LABEL.SUPERVISOR'"
                                ></span>
                              }
                              @if (i !== 0) {
                                <span
                                  [translate]="'MONLOG.LABEL.OTHER_SUPERVISOR'"
                                  [translateParams]="{ index: i }"
                                ></span>
                              }
                              @if (
                                canEdit === true &&
                                this.monLog?.id &&
                                contact['controls'].primary.value
                                  ?.isSupervisorDispatched === false
                              ) {
                                <span class="input-icon text-right">
                                  <i
                                    class="fa fa-fw fa-phone-square"
                                    (click)="
                                      dispatchContact(
                                        $safeNavigationMigration(
                                          contact['controls'].primary.value
                                            ?.supervisorId
                                        )
                                      )
                                    "
                                  ></i>
                                </span>
                              }
                              @if (
                                canEdit === true &&
                                this.monLog?.id &&
                                contact['controls'].primary.value
                                  ?.isSupervisorDispatched === true
                              ) {
                                <span class="input-icon text-right">
                                  <i
                                    class="fa fa-fw fa-home"
                                    (click)="
                                      returnContact(
                                        $safeNavigationMigration(
                                          contact['controls'].primary.value
                                            ?.supervisorId
                                        )
                                      )
                                    "
                                  ></i>
                                </span>
                              }
                              @if (contact['controls'].primary.value === null) {
                                <span class="input-icon text-right"> </span>
                              }
                            </div>
                            <span class="input-icon" style="width: 32px">
                              <i
                                class="fa fa-fw fa-id-card"
                                (click)="
                                  goToContact(
                                    contact['controls'].primary.value
                                      .supervisorId
                                  )
                                "
                              ></i>
                            </span>
                            <span class="row-input-contact">
                              <p-autoComplete
                                class="ml-contact-input"
                                formControlName="supervisor"
                                [dropdown]="true"
                                optionLabel="supervisorFullName"
                                appendTo="body"
                                [virtualScroll]="true"
                                [virtualScrollItemSize]="34"
                              />
                            </span>
                            <div class="section-element">
                              <div class="label business-mobile">
                                <span
                                  [translate]="'MONLOG.LABEL.BUSINESS_MOBILE'"
                                ></span>
                              </div>
                              <a
                                href="tel:9-1-{{
                                  contact['controls'].primary.value
                                    ?.supervisorBusinessMobile
                                }}"
                                >{{
                                  contact['controls'].primary.value
                                    ?.supervisorBusinessMobile
                                }}</a
                              >
                            </div>
                          </div>
                          <div
                            [class]="{
                              'section-element': !isEditting,
                              'edit-element': isEditting,
                              'unavailable-contact':
                                contact['controls'].primary.value
                                  ?.managerIsUnavailable,
                            }"
                          >
                            <div class="label" [class.long-label]="isEditting">
                              @if (i === 0) {
                                <span
                                  [translate]="'MONLOG.LABEL.MANAGER'"
                                ></span>
                              }
                              @if (i !== 0) {
                                <span
                                  [translate]="'MONLOG.LABEL.OTHER_MANAGER'"
                                  [translateParams]="{ index: i }"
                                ></span>
                              }
                              @if (
                                canEdit === true &&
                                this.monLog?.id &&
                                contact['controls'].primary.value
                                  ?.isManagerDispatched === false
                              ) {
                                <span class="input-icon text-right">
                                  <i
                                    class="fa fa-fw fa-phone-square"
                                    (click)="
                                      dispatchContact(
                                        contact['controls'].primary.value
                                          .managerId
                                      )
                                    "
                                  ></i>
                                </span>
                              }
                              @if (
                                canEdit === true &&
                                this.monLog?.id &&
                                contact['controls'].primary.value
                                  ?.isManagerDispatched === true
                              ) {
                                <span class="input-icon text-right">
                                  <i
                                    class="fa fa-fw fa-home"
                                    (click)="
                                      returnContact(
                                        $safeNavigationMigration(
                                          contact['controls'].primary.value
                                            ?.managerId
                                        )
                                      )
                                    "
                                  ></i>
                                </span>
                              }
                              @if (contact['controls'].primary.value === null) {
                                <span class="input-icon text-right"> </span>
                              }
                            </div>
                            <span class="input-icon" style="width: 32px">
                              <i
                                class="fa fa-fw fa-id-card"
                                (click)="
                                  goToContact(
                                    contact['controls'].primary.value.managerId
                                  )
                                "
                              ></i>
                            </span>
                            <span class="row-input-contact">
                              <p-autoComplete
                                class="ml-contact-input"
                                formControlName="manager"
                                [dropdown]="true"
                                optionLabel="managerFullName"
                                appendTo="body"
                                [virtualScroll]="true"
                                [virtualScrollItemSize]="34"
                              />
                            </span>
                            <div class="section-element">
                              <div class="label business-mobile">
                                <span
                                  [translate]="'MONLOG.LABEL.BUSINESS_MOBILE'"
                                ></span>
                              </div>
                              <a
                                href="tel:9-1-{{
                                  contact['controls'].primary.value
                                    ?.managerBusinessMobile
                                }}"
                                >{{
                                  contact['controls'].primary.value
                                    ?.managerBusinessMobile
                                }}</a
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                </p-panel>
                @if (
                  monLog?.id &&
                  (monLog?.logCategory === 'MR' || monLog?.logCategory === 'AE')
                ) {
                  <p-panel
                    header="{{ 'MONLOG.LABEL.ACTIONS_TAKEN' | translate }}"
                    styleclass="mon-log-panel"
                    [toggleable]="true"
                  >
                    <div>
                      @if (canEdit === true) {
                        <div>
                          <div class="no-padding-top-bottom">
                            <i
                              class="fa fa-fw fa-clock-o"
                              style="font-size: 1.5em"
                              title="Add Default Entry"
                              (click)="addMaintenanceEntry()"
                            ></i>
                            &nbsp;
                            <i
                              class="fa fa-fw fa-check-circle"
                              style="font-size: 1.5em"
                              title="Resolve Log"
                              (click)="addMaintenanceEntry(true)"
                            ></i>
                          </div>
                          <div class="no-padding-top-bottom">
                            <button
                              pButton
                              label="{{
                                'COMMON.LABEL.BUTTONS.ADD' | translate
                              }}"
                              icon="fa fa-fw fa-plus"
                              (click)="showEntryForm(true)"
                            ></button>
                          </div>
                        </div>
                      }
                      @for (entry of monLog?.MonLogEntries; track entry.id) {
                        <div class="entry">
                          <app-log-entry
                            [entry]="entry"
                            [canEdit]="canEdit"
                            [canDelete]="canEdit"
                            (editEvent)="editEntry($event, true)"
                            (deleteEvent)="deleteEntry($event, true)"
                          />
                        </div>
                      }
                    </div>
                  </p-panel>
                }
                <br />
              </p-tabpanel>
              @if (monLog?.id && isAlarm === true) {
                <p-tabpanel [value]="1">
                  <div>
                    @if (canUserAddAlarm()) {
                      <div class="add-button">
                        @if (canEdit === true) {
                          <div class="button-wrapper no-padding-top-bottom">
                            <button
                              pButton
                              label="{{
                                'COMMON.LABEL.BUTTONS.ADD' | translate
                              }}"
                              icon="fa fa-fw fa-plus"
                              (click)="showEntryForm()"
                              [disabled]="isEditting"
                              [pTooltip]="
                                isEditting
                                  ? 'Save monitoring log before adding entries'
                                  : undefined
                              "
                            ></button>
                          </div>
                        }
                      </div>
                    }
                    @for (entry of monLog?.MonLogAlarms; track entry.id) {
                      <div class="entry">
                        <app-log-entry
                          [entry]="entry"
                          [canEdit]="canEdit && !isEditting"
                          [canDelete]="canEdit && !isEditting"
                          (editEvent)="editEntry($event, false)"
                          (deleteEvent)="deleteEntry($event, false)"
                        />
                      </div>
                    }
                  </div>
                </p-tabpanel>
              }
              @if (
                monLog?.id &&
                monLog?.logCategory !== 'MR' &&
                monLog?.logCategory !== 'AE'
              ) {
                <p-tabpanel [value]="monLog?.id && isAlarm ? 2 : 1">
                  <div>
                    @if (canEdit === true) {
                      <div class="add-button">
                        <div class="button-wrapper no-padding-top-bottom">
                          <button
                            pButton
                            label="{{ 'COMMON.LABEL.BUTTONS.ADD' | translate }}"
                            icon="fa fa-fw fa-plus"
                            (click)="showEntryForm(true)"
                            [disabled]="isEditting"
                            [pTooltip]="
                              isEditting
                                ? 'Save monitoring log before adding entries'
                                : undefined
                            "
                          ></button>
                        </div>
                      </div>
                    }
                    @for (entry of monLog?.MonLogEntries; track entry.id) {
                      <div class="entry">
                        <app-log-entry
                          [entry]="entry"
                          [canEdit]="canEdit && !isEditting"
                          [canDelete]="canEdit && !isEditting"
                          (editEvent)="editEntry($event, true)"
                          (deleteEvent)="deleteEntry($event, true)"
                        />
                      </div>
                    }
                  </div>
                </p-tabpanel>
              }
              <p-tabpanel
                [value]="
                  monLog?.id &&
                  monLog?.logCategory !== 'MR' &&
                  monLog?.logCategory !== 'AE' &&
                  monLog?.id &&
                  isAlarm
                    ? 3
                    : (monLog?.id &&
                          monLog?.logCategory !== 'MR' &&
                          monLog?.logCategory !== 'AE') ||
                        (monLog?.id && isAlarm)
                      ? 2
                      : 1
                "
              >
                <div>
                  <div>
                    <div class="no-padding">
                      <p-panel
                        header="{{
                          'MONLOG.LABEL.CALLOUT_INFORMATION' | translate
                        }}"
                        styleclass="mon-log-panel"
                      >
                        @for (
                          callout of getCallouts();
                          track callout;
                          let j = $index
                        ) {
                          <div
                            class="no-padding-top-bottom"
                            formArrayName="MonLogCallouts"
                          >
                            <div
                              formGroupName="{{ j }}"
                              class="callout"
                              style="border-bottom: 1px solid #dedede"
                            >
                              <div class="section">
                                <span>
                                  {{ callout.controls['firstName'].value }}
                                  {{ callout.controls['lastName'].value }}
                                </span>
                              </div>
                              <div class="section">
                                <span
                                  class="label"
                                  [translate]="'MONLOG.LABEL.CALLOUT_DATE'"
                                ></span>
                                <span class="section-input">
                                  <p-datepicker
                                    formControlName="startDt"
                                    [showTime]="true"
                                    hourFormat="12"
                                  />
                                </span>
                              </div>
                              <div class="section">
                                <span
                                  class="label"
                                  [translate]="'MONLOG.LABEL.RETURN_DATE'"
                                ></span>
                                <span class="section-input">
                                  <p-datepicker
                                    formControlName="endDt"
                                    [showTime]="true"
                                    hourFormat="12"
                                    [minDate]="
                                      callout.controls['startDt'].value
                                    "
                                  />
                                </span>
                                @if (canEdit === true) {
                                  <span
                                    class="input-icon"
                                    style="margin-left: 8px"
                                  >
                                    <i
                                      class="fa fa-fw fa-trash"
                                      (click)="
                                        deleteCallout(
                                          callout.controls['id'].value
                                        )
                                      "
                                    ></i>
                                  </span>
                                }
                              </div>
                            </div>
                          </div>
                        }
                      </p-panel>
                    </div>
                    <br />
                    <br />
                    <div class="no-padding">
                      <p-panel
                        header="{{ 'MONLOG.LABEL.NOTIFICATIONS' | translate }}"
                        styleclass="mon-log-panel"
                      >
                        @for (a of monLog?.MonLogNotifications; track a.time) {
                          <div style="word-wrap: break-word; width: 600px">
                            <strong
                              >{{ a.time | date: 'yyyy-MM-dd HH:mm:ss' }} -
                              {{ a.user }}:</strong
                            >
                            {{ a.note }}
                          </div>
                        }
                      </p-panel>
                    </div>
                    <br />
                    <br />
                    <div class="no-padding">
                      <p-panel
                        header="{{ 'MONLOG.LABEL.AUDIT_LOG' | translate }}"
                        styleclass="mon-log-panel"
                      >
                        @for (a of monLog?.MonLogAudits; track a.time) {
                          <div style="word-wrap: break-word; width: 600px">
                            <strong
                              >{{ a.time | date: 'yyyy-MM-dd HH:mm:ss' }} -
                              {{ a.user }}:</strong
                            >
                            {{ a.note }}
                          </div>
                        }
                      </p-panel>
                    </div>
                  </div>
                </div>
              </p-tabpanel>
              @if (
                this.canViewEventReview() && this.doesAnyTypeRequireReview()
              ) {
                <p-tabpanel
                  [value]="
                    monLog?.id &&
                    monLog?.logCategory !== 'MR' &&
                    monLog?.logCategory !== 'AE' &&
                    monLog?.id &&
                    isAlarm
                      ? 4
                      : (monLog?.id &&
                            monLog?.logCategory !== 'MR' &&
                            monLog?.logCategory !== 'AE') ||
                          (monLog?.id && isAlarm)
                        ? 3
                        : 2
                  "
                >
                  <div>
                    @if (this.canCreateEventReviewEntries()) {
                      <div class="open-dialog">
                        <div class="button-wrapper no-padding-top-bottom">
                          <button
                            pButton
                            label="{{
                              'MONLOG.LABEL.BUTTONS.REVIEW' | translate
                            }}"
                            icon="fa fa-fw fa-plus"
                            (click)="addEventReviewEntry()"
                          ></button>
                        </div>
                      </div>
                    }
                    <div class="word-wrap">
                      @for (
                        entry of monLog?.ControlRoomEventReviewEntries;
                        track entry.id
                      ) {
                        <app-log-entry
                          [entry]="entry"
                          [canEdit]="canEditEventReviewEntry(entry)"
                          [canDelete]="canDeleteEventReviewEntry(entry)"
                          (editEvent)="editEventReviewEntry(entry)"
                          (deleteEvent)="
                            deleteControlRoomEventReviewEntry(entry)
                          "
                        />
                      }
                    </div>
                  </div>
                </p-tabpanel>
              }
            </p-tabpanels>
          </p-tabs>
        </div>
      }
    </form>
  }

  <app-mon-logs-add-entry (addEntrySaveEvent)="refresh()" />

  <app-event-review-dialog
    [monLogId]="$safeNavigationMigration(monLog?.id)"
    (entryChangedEvent)="refresh()"
  />
</blockable-div>
